import { render, staticRenderFns } from "./CmgGlobalErrorToastModal.vue?vue&type=template&id=0a66a444&scoped=true&lang=pug&"
import script from "./cmg-global-error-toast-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-global-error-toast-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGlobalErrorToastModal.vue?vue&type=style&index=0&id=0a66a444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66a444",
  null
  
)

export default component.exports